// BL2 Reformas — vanilla JS for interactive bits

// FAQ accordion
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.faq-q');
  if (!btn) return;
  var item = btn.closest('.faq-item');
  if (!item) return;
  var openSiblings = item.parentElement.querySelectorAll('.faq-item.open');
  openSiblings.forEach(function (el) { if (el !== item) el.classList.remove('open'); });
  item.classList.toggle('open');
});

// Before/After slider
function initBA(root) {
  var dragging = false;
  var before = root.querySelector('.ba-before');
  var handle = root.querySelector('.ba-handle');
  if (!before || !handle) return;
  function setPos(clientX) {
    var rect = root.getBoundingClientRect();
    var p = Math.max(2, Math.min(98, ((clientX - rect.left) / rect.width) * 100));
    before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
    handle.style.left = p + '%';
  }
  root.addEventListener('mousedown', function (e) {
    dragging = true; document.body.style.userSelect = 'none'; setPos(e.clientX);
  });
  root.addEventListener('touchstart', function (e) {
    dragging = true; setPos(e.touches[0].clientX);
  }, { passive: true });
  window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
  window.addEventListener('touchmove', function (e) { if (dragging) setPos(e.touches[0].clientX); }, { passive: true });
  window.addEventListener('mouseup', function () { dragging = false; document.body.style.userSelect = ''; });
  window.addEventListener('touchend', function () { dragging = false; });
}
document.querySelectorAll('.ba').forEach(initBA);
document.addEventListener('shopify:section:load', function (e) {
  e.target.querySelectorAll('.ba').forEach(initBA);
});
